import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";

const EASE = [0.16, 1, 0.3, 1];

const reveal = (delay = 0) => ({
  initial: { opacity: 0, y: 32 },
  whileInView: { opacity: 1, y: 0 },
  viewport: { once: true, margin: "-80px" },
  transition: { duration: 0.7, delay, ease: EASE },
});

const ITEMS = [
  { image: "/assets/unixx-5w40.jpg", name: "5W-40", tag: "Fully Synthetic" },
  { image: "/assets/unixx-10w40.jpg", name: "10W-40", tag: "Synthetic Blend" },
  { image: "/assets/unixx-15w40.jpg", name: "15W-40", tag: "Mineral Diesel" },
];

export default function UnixxStrip() {
  return (
    <section className="border-b border-navy-600/60" data-testid="unixx-strip">
      <div className="mx-auto max-w-7xl px-6 py-24 md:px-12">
        <div className="grid items-center gap-12 lg:grid-cols-2">
          <motion.div {...reveal()}>
            <p className="font-mono text-xs uppercase tracking-[0.35em] text-brand">Featured Brand</p>
            <h2 className="mt-3 text-2xl font-bold text-white sm:text-3xl">
              Unixx engine oils — blended to API &amp; OEM standards
            </h2>
            <p className="mt-4 max-w-lg text-sm leading-relaxed text-slate-400">
              Our featured finished-lubricant range for passenger cars and commercial fleets, packed in
              retail and fleet sizes with full product data sheets.
            </p>
            <motion.span whileHover={{ scale: 1.05 }} whileTap={{ scale: 0.97 }} className="mt-7 inline-block">
              <Link
                to="/lubricants"
                data-testid="unixx-strip-cta"
                className="inline-flex items-center gap-2 rounded-md bg-brand px-6 py-3 text-sm font-semibold text-navy transition-shadow duration-300 hover:shadow-[0_0_28px_rgba(0,208,132,0.4)]"
              >
                Explore the lubricants range <ArrowRight className="h-4 w-4" />
              </Link>
            </motion.span>
          </motion.div>

          <div className="grid grid-cols-3 gap-4">
            {ITEMS.map((p, i) => (
              <motion.div key={p.name} {...reveal(0.1 + i * 0.1)} whileHover={{ y: -8 }}>
                <Link
                  to="/lubricants"
                  data-testid={`unixx-strip-product-${i}`}
                  className="group block"
                  aria-label={`Unixx ${p.name} ${p.tag} — view lubricants range`}
                >
                  <div className="clip-frame overflow-hidden rounded-md border border-navy-600 transition-colors duration-300 group-hover:border-brand/50">
                    <img
                      src={p.image}
                      alt={`Unixx ${p.name} ${p.tag} engine oil`}
                      className="aspect-square w-full object-cover transition-transform duration-700 ease-out group-hover:scale-110"
                    />
                  </div>
                  <p className="mt-3 font-mono text-sm font-semibold text-white">{p.name}</p>
                  <p className="font-mono text-[10px] uppercase tracking-wider text-brand">{p.tag}</p>
                </Link>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
